import axios from "axios";

export const instance = axios.create({
  timeout: 10000
});

export const getRequestMessageList = (id, token) => {
  const response = instance({
    method: "get",
    url: `/work/api/dialog/request/${id}/messages`,
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "application/json",
    },
  });
  return response;
};

export const createRequestMessage = (id, token, data) => {
  const response = instance({
    method: "post",
    url: `/work/api/dialog/message/request/${id}`,
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "application/json",
    },
    data,
  });
  return response;
};

export default {
  getRequestMessageList,
  createRequestMessage
};
